import { combineReducers } from 'redux';
import Auth from './Auth';
import Payouts from './Payouts';
import Window from './Window';

export default combineReducers({ Auth, Payouts, Window });